import { format } from 'date-fns';
import { isNil } from 'ramda';

import { GridRenderCellParams } from '@mui/x-data-grid-pro';

interface LocalizedTimeCell {
  dateTime: GridRenderCellParams<string>['value'];
}

const LocalizedTimeCell: React.FC<LocalizedTimeCell> = ({ dateTime }) => {
  if (isNil(dateTime)) {
    return <></>;
  }

  return <>{format(new Date(dateTime), 'HH:mm')}</>;
};

export default LocalizedTimeCell;
